import { IonSkeletonText } from '@ionic/react'

import { useGoals } from '../../../hooks/outreach/queries'
import {
  useSmsSubscriberCount,
  useEmailSubscriberCount,
} from '../../../hooks/clients/queries'

type Props = {
  label: string
  stat: string
}

function OutreachStatSkeleton() {
  return (
    <div className="ion-text-center">
      <h2>
        <IonSkeletonText
          animated
          className="mx-auto my-0 w-2/5 leading-inherit"
        />
      </h2>
      <p>
        <IonSkeletonText animated className="mx-auto -mb-0.5 mt-0.5 w-3/5" />
      </p>
    </div>
  )
}

function OutreachStat({ label, stat }: Props) {
  return (
    <div className="ion-text-center">
      <h2>{stat}</h2>
      <p>{label}</p>
    </div>
  )
}

function MessageGoals() {
  const goalsQuery = useGoals()

  return (
    <>
      {goalsQuery.data ? (
        <OutreachStat
          label="Goals"
          stat={`${goalsQuery.data.thisMonthMessageCount}/${goalsQuery.data.goal}`}
        />
      ) : (
        <OutreachStatSkeleton />
      )}
    </>
  )
}

function SmsSubscribers() {
  const textSubscriberCountQuery = useSmsSubscriberCount()

  return (
    <>
      {textSubscriberCountQuery.data ? (
        <OutreachStat
          label="Text Subscribers"
          stat={textSubscriberCountQuery.data}
        />
      ) : (
        <OutreachStatSkeleton />
      )}
    </>
  )
}
function EmailSubscribers() {
  const emailSubscriberCountQuery = useEmailSubscriberCount()

  return (
    <>
      {emailSubscriberCountQuery.data ? (
        <OutreachStat
          label="Email Subscribers"
          stat={emailSubscriberCountQuery.data}
        />
      ) : (
        <OutreachStatSkeleton />
      )}
    </>
  )
}
export { MessageGoals, SmsSubscribers, EmailSubscribers }
